<template>
  <div>
    <HelpCenterHeader v-if="!isH5"></HelpCenterHeader>
    <div class="header-box" v-if="isH5">
      <PageMbHeader
        :title="isApplyCancel ? $t('申请取消原因') : $t('订单取消成功')"
        :transShow="false"
        :transOpen="false"
        :iconShow="!isNewTab"
        @icon-click="back"
      />
    </div>
    <template v-if="errCode">
      <EmptyState emptyType="noNetwork" @tryAgain="getCancelReason" />
    </template>
    <template v-else>
      <div class="content">
        <div class="cancel-reason-content" v-r-loading="loading">
          <div class="reason-list">
            <div class="desc-content">
              <div class="title">{{ title }}</div>
              <div class="desc">{{ desc }}</div>
            </div>
            <div class="option-content">
              <div v-for="option in options" :key="option.value">
                <el-radio v-model="reasonVal" :label="option.value">{{
                  option.label
                }}</el-radio>
                <div class="else-reason-cont" v-if=" isOtherReason & option.value === OTHER_REASON_ERROR_CODE">
                  <el-input
                    type="textarea"
                    class="txt-area"
                    :placeholder="$t('FoodC_reasons_Enter_a_Pnzg' /* 请输入具体原因 */)"
                    v-model="writeReason"
                    maxlength="200"
                    resize="none"
                    show-word-limit
                  >
                  </el-input>
                </div>
                <div class="border"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="button-content">
          <el-button
            v-if="showSkipBtn"
            :dark="true"
            :outline="true"
            @click="handleSkipChooseReason"
            class="btn"
          >
            {{ $t('跳过') }}
          </el-button>
          <el-button
            :disabled="disabled"
            :loading="btnLoading"
            @click="handleCancelOrder"
            class="btn"
          >
            {{ $t('确认') }}
          </el-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import api from '@/api';
import { get, debounce } from 'lodash-es';
import HelpCenterHeader from '@/components/HelpCenterHeader';
import PageMbHeader from '@/components/PageMbHeader';
import { mapState } from 'vuex';
import EmptyState from '@/components/EmptyState';
import { ERROR_CODE, REFRESH_TIME } from '../const';
import { requestCommonParams } from '@/lib/request/requestCommonParams';
import { getIsNewTab } from '@/utils/tools';
const OTHER_REASON_ERROR_CODE = 319999 // 定义特殊状态码 其他原因情况
const DEFAULT_REASON_ERROR_CODE = -1 // 定义特殊状态码，和rd确定不存在负数情况

export default {
  name: 'cancelOrderReason', // 取消订单
  components: {
    HelpCenterHeader,
    PageMbHeader,
    EmptyState,
  },
  data() {
    return {
      options: [],
      reasonVal: DEFAULT_REASON_ERROR_CODE,
      desc: this.$t('请告诉我们，帮助我们一起改善'),
      loading: false,
      errCode: null,
      writeReason: '',
      OTHER_REASON_ERROR_CODE: OTHER_REASON_ERROR_CODE
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      isNewTab() {
        return getIsNewTab();
      },
    }),
    disabled() {
      return this.reasonVal === DEFAULT_REASON_ERROR_CODE;
    },
    isOtherReason () {
      return this.reasonVal === OTHER_REASON_ERROR_CODE
    },
    cancelSuccessText() {
      return get(this, '$route.query.cancelSuccessText', '');
    },
    // 是否来自提交申请
    isApplyCancel() {
      return this.$route.query.type === 'applyCancel';
    },
    title() {
      return this.isApplyCancel
        ? this.$t('请选择取消原因以便商家更快帮您处理')
        : this.$t('您为什么取消？');
    },
    wrapperHeightStyle() {
      return '400px';
    },
    showSkipBtn() {
      // 判断是否为商家接单前流程
      return get(this, '$route.query.orderStatus', null) < 200;
    },
  },
  methods: {
    // 获取取消原因
    async getCancelReason() {
      try {
        this.loading = true;
        const orderId = get(this, '$route.query.orderId', null);
        const res =
          (await api.getCancelReason({
            orderId,
          })) || {};
        const reasonList = get(res, 'reasonList', []);
        this.options =
          reasonList.map((list) => {
            return {
              value: list.eventCode,
              label: list.reason,
            };
          }) || [];
        this.loading = false;
        this.errCode = null;
      } catch (error) {
        const errno = get(error, 'errno', null);
        // 关闭订单已完成页面
        if (+errno === ERROR_CODE.ORDER_STATUS_UPDATE) {
          this.goOrderList();
        } else if (+errno === ERROR_CODE.INFO_UPDATE) {
          setTimeout(() => {
            this.getCancelFlow();
          }, REFRESH_TIME);
        } else {
          this.errCode = errno;
          this.loading = false;
        }
      } finally {
        this.loading = false;
      }
    },
    // 提交取消
    handleCancelOrder: debounce(async function () {
      if (this.isApplyCancel) {
        this.submitCancelOrder();
      } else {
        this.submitCancelReason();
      }
    }, 300),
    // 提交取消订单
    async submitCancelOrder() {
      try {
        const msg = this.getMsg()
        this.loading = true;
        const orderId = get(this, '$route.query.orderId', null);
        await api.applyCancel({
          orderId,
          reasonCode: this.reasonVal,
          writeReason: this.isOtherReason ? this.writeReason : '',
          reasonMsg: msg,
        });
        this.loading = false;
        this.handleCancelOrderSuc(1);
      } catch (error) {
        // 关闭订单已完成页面
        const errno = get(error, 'errno', null);
        if (+errno === ERROR_CODE.ORDER_STATUS_UPDATE) {
          this.goOrderList();
        } else if (+errno === ERROR_CODE.INFO_UPDATE) {
          setTimeout(() => {
            this.submitCancelOrder();
          }, REFRESH_TIME);
        } else {
          this.errCode = errno;
          this.loading = false;
        }
      }
    },
    goOrderDetail() {
      const orderId = get(this, '$route.query.orderId');
      if (!orderId) return;
      this.$router.push({
        path: '/orderDetail/',
        query: {
          orderId,
        },
      });
    },
    goOrderList() {
      this.$router.push({
        path: '/order/',
      });
    },
    // 提交取消成功挑战逻辑
    handleCancelOrderSuc(isCancelApply) {
      // 提交是否成功，0失败，1成功---取消申请提交,0不是,1是
      // 如果是向商家提交申请则返回订单页面
      // 否则跳转至取消结果页面
      if (isCancelApply) {
        this.goOrderDetail();
      } else {
        this.gotoCancelResult();
      }
    },
    // 提交取消原因
    async submitCancelReason() {
      const msg = this.getMsg();
      try {
        this.loading = true;
        const commonParams = await requestCommonParams();
        await api.submitCancelReason(
          Object.assign(
            {
              orderId: this.$route.query.orderId,
              orderCityId: this.$route.query.orderCityId,
              judgeId: this.$route.query.judgeId,
            },
            {
              optionId: this.reasonVal,
              msg,
              writeReason: this.isOtherReason ? this.writeReason : '',
              orderCityId: commonParams.cityId,
            }
          )
        );
        this.errCode = null;
        this.handleCancelOrderSuc(0);
        this.cancelReasonSubmitTrack({
          reason_code: this.reasonVal,
          is_suc: 1,
          failure_reason: '',
          is_cancel_apply: 1,
        });
      } catch (error) {
        const errno = get(error, 'errno', null);
        this.errCode = errno;
        this.cancelReasonSubmitTrack({
          reason_code: this.reasonVal,
          is_suc: 0,
          failure_reason: error,
          is_cancel_apply: 1,
        });
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    // 管控需要提交原因，后端又添加了一个字段msg
    getMsg() {
      const reasonVal = get(this, 'reasonVal', -1);
      const options = get(this, 'options', []);
      for (let i = 0; i < options.length; i++) {
        if (options[i].value === reasonVal) {
          return options[i].label;
        }
      }
      return '';
    },
    // 跳过取消原因提交
    handleSkipChooseReason() {
      this.gotoCancelResult();
    },
    // 跳转至取消结果页面
    gotoCancelResult() {
      const query = this.$route.query;
      this.$router.replace({
        name: 'CancelOrderResult',
        query,
      });
    },
    cancelReasonSubmitTrack(params) {
      const orderId = get(this, '$route.query.orderId', '');
      const orderStatus = get(this, '$route.query.orderStatus', '');
      this.$trackEvent({
        eventId: 'sailing_c_x_cancelreason_submit_ck',
        eventLabel: '取消订单原因页面提交按钮',
        attrs: Object.assign(
          { order_id: orderId, order_status: orderStatus },
          params
        ),
      });
    },
    cancelReasonTrack() {
      const orderId = get(this, '$route.query.orderId', '');
      const orderStatus = get(this, '$route.query.orderStatus', '');
      this.$trackEvent({
        eventId: 'sailing_c_x_cancelreason_common_sw',
        eventLabel: '取消订单原因页面展示',
        attrs: {
          order_id: orderId,
          order_status: orderStatus,
        },
      });
    },
    back() {
      this.$router.go(-1);
    },
  },
  created() {
    this.getCancelReason();
    this.cancelReasonTrack();
  },
};
</script>
<style lang="scss">
.cancel-reason-content {
  .el-radio {
    width: 100%;
    padding: 20px 70px 20px 24px;
    font-family: 'Aspira Light';
    font-size: 14px;
    line-height: 18px;
    color: #000000;
    letter-spacing: 0;
    display: block;
    &.is-checked {
      letter-spacing: 0;
      font-family: 'Aspira Medium';
    }
    &:hover {
      background: #f5f5f7;
    }
    .el-radio__input {
      position: static;
    }
    .el-radio__inner {
      position: absolute;
      right: 24px;
      top: 20px;
    }
    .el-radio__label {
      font-size: 14px;
      line-height: 18px;
      padding-right: 16px;
      padding-left: 0;
    }
  }
}
@media screen and (max-width: 768px) {
  .cancel-reason-content {
    .el-radio {
      width: 100%;
      padding: rem(54) rem(134) rem(48) rem(18);
      font-family: 'Aspira Light';
      font-size: rem(28);
      line-height: rem(34);
      color: #000000;
      letter-spacing: 0;
      &.is-checked {
        letter-spacing: 0;
        .el-radio__inner {
          box-shadow: none !important;
        }
      }
      &:hover {
        background: transparent;
      }
      .el-radio__input {
        position: static;
      }
      .el-radio__inner {
        position: absolute;
        right: rem(32);
        width: rem(40);
        height: rem(40);
        top: rem(48);
        border-color: transparent;
        border-style: solid;
        overflow: hidden;
      }
      .el-radio__label {
        padding-right: rem(32);
        padding-left: 0;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import '../../control_global.scss';
.content {
  height: calc(100vh - #{$pc_cont_height});
  position: relative;
  max-width: 940px;
  margin: 0 auto 80px;
}
.button-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: right;
  height: 80px;
  padding-right: 20px;
  background: #ffffff;
  .btn {
    margin: 20px 0 20px 20px;
    min-width: $pc_button_min_width;
    &.is-dark {
      background: #fff;
    }
  }
}
.cancel-reason-content {
  height: 100%;
  overflow-y: auto;
  border-radius: 8px;
  background: #fff;
  .title {
    margin: 0 24px 10px;
    font-family: 'Aspira Medium';
    font-size: 24px;
    line-height: 28px;
    color: #000000;
  }
  .desc {
    margin: 0 24px 8px;
    font-family: 'Aspira Light';
    font-size: 14px;
    line-height: 18px;
    color: #999999;
  }
  .reason-list {
    min-height: 520px;
    margin: 32px 0 84px;
  }
  .border {
    margin: 0 24px;
    height: 1px;
    background: #e5e5e5;
    border-radius: 4px;
  }
  .else-reason-cont {
    margin: 0 24px 24px 24px;
  }
}
// 移动端适配
@media screen and (max-width: 768px) {
  .header-box {
    position: sticky;
    top: 0;
    z-index: 9;
  }
  .content {
    margin: 0 auto;
    padding: rem(94) 0 0;
    height: auto;
    min-height: calc(100vh - #{$h5_btn_height});
  }
  .button-content {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: right;
    height: rem(166);
    padding: 0 rem(28) 0 rem(18);
    background: transparent;
    display: flex;
    .btn {
      flex: 1;
      margin: rem(38) rem(9);
    }
  }
  .cancel-reason-content {
    height: 100%;
    position: relative;
    margin: 0 auto;
    max-width: none;
    background: #f5f5f7;
    .option-content {
      background: #fff;
      margin: 0 rem(24);
      border-radius: rem(12);
    }
    .title {
      margin: rem(20) rem(32) rem(32);
      font-family: 'Aspira Medium';
      font-size: rem(44);
      line-height: rem(52);
      color: #000000;
    }
    .desc {
      margin: 0 rem(32) rem(48);
      font-family: 'Aspira Light';
      font-size: rem(28);
      line-height: rem(34);
      color: #000;
    }
    .reason-list {
      min-height: 520px;
      margin: rem(22) 0 rem(186);
      overflow: auto;
    }
    .border {
      margin: 0 rem(18);
      height: rem(1);
      background: #e5e5e5;
      border-radius: rem(4);
    }
    .else-reason-cont {
      margin: 0 rem(32) rem(64) rem(18);
    }
  }
}
</style>
